/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/fetch";
import type { GetDrawingPMTilesURLQueryResponse, GetDrawingPMTilesURLPathParams, GetDrawingPMTilesURL422 } from "../models/drawingClient/GetDrawingPMTilesURL";
import type { RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/fetch";

function getGetDrawingPMTilesURLUrl(project_uuid: GetDrawingPMTilesURLPathParams["project_uuid"], file_uuid: GetDrawingPMTilesURLPathParams["file_uuid"]) {
  const res = { method: 'GET', url: `/v1/drawings/${project_uuid}/${file_uuid}/pmtiles-url` as const }  
  return res
}

/**
 * @description Returns a url for a PMTiles file for a drawing.
 * @summary Get a url for a PMTiles file for a drawing
 * {@link /v1/drawings/:project_uuid/:file_uuid/pmtiles-url}
 */
export async function getDrawingPMTilesURL(project_uuid: GetDrawingPMTilesURLPathParams["project_uuid"], file_uuid: GetDrawingPMTilesURLPathParams["file_uuid"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetDrawingPMTilesURLQueryResponse, ResponseErrorConfig<GetDrawingPMTilesURL422>, unknown>({ method : "GET", url : getGetDrawingPMTilesURLUrl(project_uuid, file_uuid).url.toString(), ... requestConfig })  
  return res.data
}